import PosterFrameHandler from "./../PosterFrameHandler.js";

export default class DetailEventHandler
{
    /**
     * @param $baseElement
     */
    constructor($baseElement) {
        this.$baseElement = $baseElement;
    }
    /**
     * @returns {DetailEventHandler}
     */
    static make($baseElement) {
        return new this($baseElement);
    }

    /**
     * @returns {DetailEventHandler}
     */
    disableRightClick() {
        if (!jQuery('body.logged-in').length) {
            document.addEventListener('contextmenu', event => event.preventDefault());
        }
        return this;
    }

    /**
     * Remove plus signs from drop down options
     */
    removePlus() {
        let $firstDropdownOptions = this.$baseElement.find('.wapf-wrapper select:first option');
        $firstDropdownOptions.each(function() {
            let optionInnerHtml = jQuery(this).html();
            jQuery(this).html(optionInnerHtml.replace('+', ''))
        })
        return this;
    }
    /**
     * Count the order amount up and down
     */
    productQuantityUpAndDown() {
        let $firstDropdownOptions = this.$baseElement.find('.wapf-wrapper select:first option');
        const $minusButton = this.$baseElement.find('.woo-quantity-minus');
        const $plusButton = this.$baseElement.find('.woo-quantity-plus');
        $minusButton.on('click', () => {
            const $quantityField = this.$baseElement.find('.input-text.qty.text');
            let quantity = parseInt($quantityField.val());
            if (quantity > 1) {
                --quantity;
            }
            $quantityField.val(quantity);
        });
        $plusButton.on('click', () => {
            const $quantityField = this.$baseElement.find('.input-text.qty.text');
            let quantity = parseInt($quantityField.val());
            $quantityField.val(++quantity);
        });
        $firstDropdownOptions.each(function() {
            let optionInnerHtml = jQuery(this).html();
            jQuery(this).html(optionInnerHtml.replace('+', ''))
        })
        return this;
    }
    /**
     * Replace button separator with <br> to make it show on two lines
     */
    replaceButtonSeparator() {
        jQuery(document).find('.wapf-swatch--text').each(function() {
            let text = jQuery(this).html();
            let chunks = text.split('|');
            jQuery(this).html('<div class="title">' + chunks[0].trim() + '</div><div class="subtitle">' + chunks[1] + '<div>' + chunks[2]);

            let html = '';
            if (typeof chunks[0].trim() !== 'undefined') {
                html += '<div class="title">' + chunks[0].trim() + '</div>';
            }
            if (typeof chunks[1] !== 'undefined') {
                html += '<div class="subtitle">' + chunks[1] + '<div>';
            }
            if (typeof chunks[2] !== 'undefined') {
                html += chunks[2];
            }
            jQuery(this).html(html);
        });

        return this;
    }

    /**
     * @returns this
     */
    addCheckMarkToButtons() {
        jQuery(document).find('.wapf-swatch').each(function() {
            jQuery(this).prepend('<i class="fas fa-check"></i>');
        });
        return this;
    }

    /**
     * @returns this
     */
    addLabelsToButtons() {
        jQuery(document).find('.wapf-swatch .title').each(function() {
            if (jQuery(this).text() === 'Large') {
                jQuery(this).parent().prepend('<span class="badge recommended">populær</span>')
            }
        });
        return this;
    }

    /**
     * Remove the first dropdown option from variants on the product detail page
     */
    removeFirstDropdownOption() {
        this.$baseElement.find('.variations select').each(function() {
            jQuery(this).find("option").eq(0).remove();
        });
        return this;
    }
    /**
     * @returns this
     */
    addWithFrameText() {
        let $frameTextSpans = jQuery(document).find('.wapf-field-label.wapf--above span');
        $frameTextSpans.each(function() {
            if (jQuery(this).text() === 'Ramme' ||
                jQuery(this).text() === '2 rammer' ||
                jQuery(this).text() === '3 rammer'
            ) {
                jQuery(this).html(jQuery(this).text() + ' <span class="frame-incl-mount">(inkl. montering)</span>')
            }
        });
        return this;
    }
    /**
     * @returns this
     */
    addPosterFrame(frameImagePreloader) {
        let $image = jQuery(document).find('.single-product .woocommerce-product-gallery__image a img.wp-post-image');
        if (!$image.length) {
            return this;
        }
        let posterFrameHandler = new PosterFrameHandler({
            images : $image,
            frameImagePreloader : frameImagePreloader,
            frameShadowOffset : 0,
            framePadding : 0,
            onclickSelectors : [
                jQuery(document).find('.swoo-text-swatch'),
                jQuery(document).find('.swoo-image-swatch'),
                jQuery(document).find('.variations select')
            ],
            //hiddenSelectorToShowAfterLoad: '.woocommerce-product-gallery'
        });
        posterFrameHandler.addFrames(function() {
            jQuery(document).find('.lion-badge').show();
        });
        return this;
    }

    /**
     * @returns this
     */
    addQualityGuide() {
        const $customProductData = jQuery(document).find('.custom-product-data');
        let isPoster = $customProductData.data('is-poster');
        if (!isPoster) {
            return this;
        }
        let aboutQualityText = $customProductData.data('about-quality-text') || '';
        // Add the quality guide to the product detail page
        jQuery(document).find('.single-product .woocommerce-product-gallery').append('<div class="quality-guide"><a href="#" data-bs-toggle="modal" data-bs-target="#quality-guide-modal">' + aboutQualityText + '<i class="fa fa-info-circle" aria-hidden="true"></i></a></div>');
        return this;
    }

    /**
     * @returns this
     */
    addSpinner() {
        let isPoster = jQuery(document).find('.custom-product-data').data('is-poster');
        if (!isPoster) {
            return this;
        }

        let spinnerImage = new Image();
        spinnerImage.src = '/wp-content/themes/orchid-store-kc/assets/dist/img/spinner.gif';
        spinnerImage.setAttribute('class', 'spinner');
        jQuery(spinnerImage).insertBefore(jQuery(document).find('.single-product .woocommerce-product-gallery'));
        return this;
    }

    waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    /**
     * @returns this
     */
    showTpReviewsOnClick() {
        jQuery('.tp-see-more-reviews #see-more-reviews').click(function(e) {
            const $tpWrapper = jQuery('.tp-wrapper');
            if (!$tpWrapper.hasClass('expand-mobile')) {
                $tpWrapper.addClass('expand-mobile');
                jQuery(this).hide();
            }
        });
        return this;
    }

    /**
     * @returns this
     */
    showNoFrameTextWhenClickingOnExtraLarge() {
        this.$baseElement.find('.swoo-text-swatch').on('click', function() {
            if (jQuery(this).find('.swoo-title').text().trim() === 'Extra large') {
                jQuery(document).find('.single-product .extra-large-notice').show();
                jQuery(document).find('.single-product .swoo-field-html').hide();
            } else {
                jQuery(document).find('.single-product .extra-large-notice').hide();
                jQuery(document).find('.single-product .swoo-field-html').show();
            }
        });
        return this;
    }

    /**
     * @returns this
     */
    fixViewportSizeIssue() {
        jQuery(window).on('load', function() {
            jQuery(document).find('.flex-viewport').height(461);
        });
        return this;
    }

    /**
     * @returns this
     */
    setProductSku() {
        let $form = jQuery('form.variations_form');
        const $productSku = jQuery('#product-sku');
        let productNumberText = $productSku.data('number-text');
        let isVariable = $productSku.data('is-variable');
        if (!isVariable) {
            return this;
        }
        $form.on('show_variation', function(event, data){
            jQuery('#product-sku').text(productNumberText + data.sku);
        });
        $form.on('hide_variation', function(){
            jQuery('#product-sku').text('');
        });
        return this;
    }
}
